class MultiMap {
    constructor() {
        this.inner = new Map();
        this.size = 0;
    }
    add(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            s = new Set();
            this.inner.set(key, s);
        }
        if (!s.has(value)) {
            s.add(value);
            this.size = this.size + 1;
        }
    }
    addMany(key, values) {
        let s = this.inner.get(key);
        if (s === undefined) {
            s = new Set();
            this.inner.set(key, s);
        }
        for (const value of values) {
            if (!s.has(value)) {
                s.add(value);
                this.size = this.size + 1;
            }
        }
    }
    delete(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            return false;
        }
        let ret = s.delete(value);
        if (s.size === 0) {
            this.inner.delete(key);
        }
        if (ret) {
            this.size = this.size - 1;
        }
        return ret;
    }
    deleteKey(key) {
        const vals = this.inner.get(key);
        if (vals !== undefined) {
            this.size = this.size - vals.size;
        }
        return this.inner.delete(key);
    }
    get(key) {
        let result = this.inner.get(key);
        if (result === undefined) {
            return new Set();
        }
        else {
            return new Set(result);
        }
    }
    getSize(key) {
        var _a;
        return ((_a = this.inner.get(key)) === null || _a === void 0 ? void 0 : _a.size) || 0;
    }
    hasKey(key) {
        return this.inner.has(key);
    }
    has(key, value) {
        const kv = this.inner.get(key);
        return kv !== undefined && kv.has(value);
    }
    asMap() {
        return new Map(this.inner.entries());
    }
    keys() {
        return this.inner.keys();
    }
    values() {
        return this.inner.values();
    }
    entries() {
        return this.inner.entries();
    }
    static fromEntries(entries) {
        const result = new MultiMap();
        result.inner = new Map([...entries].map(([k, v]) => [k, new Set(v)]));
        return result;
    }
    clone() {
        const clone = new MultiMap();
        for (const [k, s] of this.inner.entries()) {
            clone.inner.set(k, new Set(s));
        }
        return clone;
    }
}
export { MultiMap };
